import { render, staticRenderFns } from "./Hoax.vue?vue&type=template&id=1494110a&scoped=true"
import script from "./Hoax.vue?vue&type=script&lang=js"
export * from "./Hoax.vue?vue&type=script&lang=js"
import style0 from "./Hoax.vue?vue&type=style&index=0&id=1494110a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1494110a",
  null
  
)

export default component.exports